import { t } from "ttag";
import { z } from "zod";

import {
  imperialBmiInputsSchema,
  metricBmiInputsSchema,
  weightSchema,
} from "@/shared/models";
import {
  MAX_ENTRY_NOTE_CHARACTERS,
  UNIT_SYSTEM,
} from "@/shared/models/constants";

const Entry = z.object({
  id: z.string().min(1, { error: () => t`Id is required` }),
  date: z.iso.date({ error: () => t`Date is required` }),
  note: z
    .string()
    .max(MAX_ENTRY_NOTE_CHARACTERS, { error: () => "Note is too long" })
    .optional(),
});

export const WeightEntry = Entry.extend({
  weight: weightSchema,
});
export type WeightEntry = z.infer<typeof WeightEntry>;

const ImperialWeightEntry = Entry.omit({ id: true }).extend({
  unitSystem: z.literal(UNIT_SYSTEM.IMPERIAL),
  weight: imperialBmiInputsSchema.shape.weightInPounds,
});

const MetricWeightEntry = Entry.omit({ id: true }).extend({
  unitSystem: z.literal(UNIT_SYSTEM.METRIC),
  weight: metricBmiInputsSchema.shape.weightInKilograms,
});

export const WeightEntryInput = z.discriminatedUnion("unitSystem", [
  ImperialWeightEntry,
  MetricWeightEntry,
]);
